import { _ } from "../../../../core/polyglot/polyglot.js";
import AccessRight from "./AccessRight.js";

let instance;

/**
 * TODO: write documentation
 */
export default class ReadWriteAccessRight extends AccessRight {
	isReadWrite() {
		return true;
	}

	getLabel() {
		return _("Read & Write");
	}

	static getType() {
		return "Editor";
	}

	static instance() {
		instance ||= new this();

		return instance;
	}
}
